(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-submenu"] && !Shopify.designMode) return;
  try {
    (() => {
    // One overlay for the whole page, appended to <body> so it is not trapped
    // inside the header's stacking context.
    const getOverlay = () => {
      let el = document.querySelector('.mega-submenu-overlay');
      if (!el) {
        el = document.createElement('div');
        el.className = 'mega-submenu-overlay';
        document.body.appendChild(el);
      }
      return el;
    };

    const init = () => {
      document.querySelectorAll('.mega-submenu--panel').forEach((panel) => {
        if (panel.dataset.msInit === '1') return;
        panel.dataset.msInit = '1';

        const li = panel.closest('li');
        if (!li) return;
        const opener = li.querySelector('a.header__menu-item');

        const tabs = panel.querySelectorAll('.mega-submenu__tab');
        const triggers = panel.querySelectorAll('.mega-submenu__submenu-item-trigger');

        /* ---------- 2. open / close ---------- */
        const overlay = getOverlay();
        const alpha = getComputedStyle(panel)
          .getPropertyValue('--mega-submenu-overlay-alpha').trim() || '0.6';
        overlay.style.backgroundColor = `rgba(255, 255, 255, ${alpha})`;

        const open = () => {
          li.classList.add('mega-submenu-open');
          overlay.classList.add('is-visible');
          if (opener) opener.setAttribute('aria-expanded', 'true');
        };
        const close = () => {
          li.classList.remove('mega-submenu-open');
          overlay.classList.remove('is-visible');
          if (opener) opener.setAttribute('aria-expanded', 'false');
          // reset so the next open starts from a clean slate
          panel.querySelectorAll('.active').forEach((el) => el.classList.remove('active'));
          triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        };

        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
          opener.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            li.classList.contains('mega-submenu-open') ? close() : open();
          });
        }

        // Clicks inside the panel must not bubble up and close it
        panel.addEventListener('click', (event) => event.stopPropagation());

        // Click anywhere else closes it
        document.addEventListener('click', (event) => {
          if (!li.contains(event.target)) close();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') close();
        });

        /* ---------- Layer 3 -> Layer 4 ---------- */
        const showSubpanel = (groupId) => {
          const prefix = `${groupId.split('-')[0]}-`;
          [...triggers]
            .filter((t) => t.getAttribute('data-group-id').startsWith(prefix))
            .forEach((t) => {
              const isMatch = t.getAttribute('data-group-id') === groupId;
              t.classList.toggle('active', isMatch);
              t.setAttribute('aria-expanded', isMatch);
            });

          panel.querySelectorAll('.mega-submenu__subpanel').forEach((sp) => {
            sp.classList.toggle('active', sp.getAttribute('data-group-id') === groupId);
          });
        };

        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            showSubpanel(trigger.getAttribute('data-group-id'));
          });
        });

        /* ---------- Layer 2 -> Layer 3 ---------- */
        tabs.forEach((tab, tabIndex) => {
          tab.addEventListener('click', (event) => {
            // Layer 2 items with no Layer 3 navigate straight away
            if (tab.classList.contains('mega-submenu__tab--direct')) return;

            const isLink = tab.tagName === 'A';
            const alreadyActive = tab.classList.contains('active');

            // For clickable top-level items: first click selects, second navigates
            if (!isLink || !alreadyActive) event.preventDefault();

            const tabId = tab.getAttribute('data-tab-id');
            tabs.forEach((t) => t.classList.toggle('active', t === tab));
            panel.querySelectorAll('.mega-submenu__submenu').forEach((p) => {
              p.classList.toggle('active', p.getAttribute('data-tab-id') === tabId);
            });

            // Layer 4 stays closed until the user clicks a Layer 3 item
            triggers.forEach((t) => {
              t.classList.remove('active');
              t.setAttribute('aria-expanded', 'false');
            });
            panel.querySelectorAll('.mega-submenu__subpanel').forEach((sp) =>
              sp.classList.remove('active')
            );
          });
        });
      });
    };

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();
  } catch(e) { console.error(e); }
})();

})();
